import React from "react";

import { OnlineLink } from "components";
import { getMerchantPageUrlById } from "helpers";

import styles from "../residualsModal.module.scss";

const midColumn = () => ({
	Header: "MID",
	accessor: "merchant_id",
	disableSortBy: true,
	classNameCell: styles.midColumnCell,
	classNameHeader: styles.midColumnCell,
	Cell: ({ value, row: { original } }) => {
		const linkToMerchant = getMerchantPageUrlById(value);

		return linkToMerchant ? (
			<OnlineLink
				onClick={e => e.stopPropagation()}
				to={linkToMerchant}
				target="_blank"
			>
				{original?.merchant_number}
			</OnlineLink>
		) : (
			original?.merchant_number
		);
	},
});

export default midColumn;
